import Api from './Api';

class FotoMagistradoApi extends Api {
    /**
     * @param {string} cpf
     */
    async recuperar(cpf) {
        const url = this.configuracao.urlFotosMagistrados + cpf;
        const result = await this.fetch(url, 'GET', null, null, 'arraybuffer');
        return result.data;
    }
}

export default FotoMagistradoApi;
